import { render } from "./Contact.vue?vue&type=template&id=c89b9bd8&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=c89b9bd8&scoped=true&lang=css"

import exportComponent from "/home/rainnya_lime/桌面/project/waydro.id/Waydro.id/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89b9bd8"]])

export default __exports__